'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DEFAULT_TIMEZONE = exports.DEFAULT_TIMEZONE = 'Europe/London';
var DEFAULT_URL = exports.DEFAULT_URL = 'http://sports.williamhill.com/betting/en-gb';
//# sourceMappingURL=defaults.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/redux-global-settings/dist/main/defaults.js
// module id = 134
// module chunks = 0